@if (company) {
  <view-salesflow [taskflowId]="''" [companyId]="company.id" />
}
@if (company) {
  <panel width="450">
    <h1>{{ company.name }}</h1>
    <data-table>
      <data-row>
        <label>{{ 'general.address' | translate }}</label>
        {{ company.address }}<br />
        {{ company.zip }} {{ company.city }}
      </data-row>
      <data-row>
        <label>{{ 'general.phone' | translate }}</label>
        @if (!hasNumber(company)) {
          <span>{{ 'general.na' | translate }}</span>
        }
        @if (hasNumber(company)) {
          <a href="tel:{{ getNumber(company) }}">{{ getNumber(company) }}</a>
        }
      </data-row>
      <data-row>
        <label>{{ 'company.vat-number' | translate }}</label>
        <a target="_blank" href="https://datacvr.virk.dk/data/visenhed?enhedstype=virksomhed&id={{ company.vatNumber }}">{{ company.vatNumber }}</a>
      </data-row>
      <data-row>
        <label>{{ 'general.email' | translate }}</label>
        @if (!hasEmail(company)) {
          <span>{{ 'general.na' | translate }}</span>
        }
        @if (hasEmail(company)) {
          <a href="mailto:{{ getEmail(company) }}">{{ getEmail(company) }}</a>
        }
      </data-row>
    </data-table>
    @if (leadCompany) {
      <h2>{{ 'general.additional-information' | translate }}</h2>
      <data-table>
        <data-row>
          <label>{{ 'general.homepage' | translate }}</label>
          @if (!leadCompany.homepage) {
            <span>{{ 'general.na' | translate }}</span>
          }
          @if (leadCompany.homepage) {
            <a href="{{ getAdaptedUrl(leadCompany.homepage) }}" target="_blank">{{ getAdaptedUrl(leadCompany.homepage) }}</a>
          }
        </data-row>
        @if (leadCompany.industryCodes) {
          <data-row>
            <label>{{ 'company.business' | translate }}</label>
            <span>{{ leadCompany.industryCodes.join(', ') }}</span>
          </data-row>
        }
        <data-row>
          <label>{{ 'company.foundation-date' | translate }}</label>
          {{ leadCompany.foundationDate | customDate: 'shortDate' }}
        </data-row>
        <data-row>
          <label>{{ 'company.form-of-company' | translate }}</label>
          {{ leadCompany.formOfCompany }}
        </data-row>
      </data-table>
    }
  </panel>
}
